import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Row } from 'react-bootstrap';
import cx from 'classnames';

import OpenStreetMap from '../../OpenStreetMap/OpenStreetMap';
import { listingLocation } from '../../../helpers/listingLocation';
import s from './LocationMap.css';

class LocationMap extends React.Component {
  static propTypes = { data: PropTypes.object, formatMessage: PropTypes.any };

  render() {
    const { data } = this.props;
    const { point, address, municipalityReference } = listingLocation(data);
    const zoom = municipalityReference ? 12 : 16;

    return <Row className={cx(s.pageContent, 'viewListingMap')}>
      <div className={cx(s.space2, s.horizontalLineThrough)}>
        <h2 className={cx(s.sectionTitleText, s.space2)}>{municipalityReference ? 'Ubicación del municipio' : 'Ubicación exacta'}</h2>
      </div>
      <div className={s.space2}>
        <div className={s.locationNameCss}>{address}</div>
        {point ? <>
          <OpenStreetMap center={point} zoom={zoom} minZoom={5} maxZoom={19} height={350} showLocationPin
            locationPinTitle={municipalityReference ? `Referencia municipal: ${data.city}, ${data.state}` : 'Ubicación exacta registrada'} />
          <p className={s.locationSmallText}>{municipalityReference
            ? `Referencia del municipio de ${data.city}, ${data.state}. El punto de encuentro de la experiencia debe confirmarse con el anfitrión.`
            : `Punto exacto registrado por el anfitrión: ${point.lat.toFixed(6)}, ${point.lng.toFixed(6)}.`}</p>
          <a className={s.mapLink} href={`https://www.openstreetmap.org/?mlat=${point.lat}&mlon=${point.lng}#map=${zoom}/${point.lat}/${point.lng}`} target="_blank" rel="noopener noreferrer">Ver ubicación en OpenStreetMap</a>
        </> : <p className={s.locationSmallText} role="status">El anfitrión debe actualizar el punto exacto en el mapa. La dirección registrada se muestra arriba.</p>}
        <div className={s.listingLine}></div>
      </div>
    </Row>;
  }
}

export default withStyles(s)(LocationMap);
